"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("../constant");

var _contextualSearchWidget = _interopRequireDefault(require("../ContextualSearchWidget/contextualSearchWidget.proptypes"));

var _data = require("./data");

var _constant3 = require("./constant");

var _default = {
  PropTypes: {
    data: _propTypes.object.isRequired,
    endpointConfig: _propTypes.array.isRequired,
    onSubmit: _propTypes.func,
    viewport: (0, _propTypes.oneOf)(Object.values(_constant2.DEVICE_TYPE)),
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    locale: _propTypes.string,
    geoid: _propTypes.string,
    currency: _propTypes.string,
    environment: (0, _propTypes.oneOf)(Object.values(_constant3.ENVIRONMENT)),
    enableDataVisor: _propTypes.bool,
    isEdit: _propTypes.bool,
    enableLFC: _propTypes.bool,
    hasBanner: _propTypes.bool,
    bannerData: (0, _propTypes.shape)({
      imageURL: _propTypes.string,
      headline: _propTypes.string,
      subheadline: _propTypes.string,
      tags: [{
        label: _propTypes.string,
        url: _propTypes.string,
        color: _propTypes.string,
        backgroundColor: _propTypes.string
      }]
    }),
    cityLevelGrouping: _propTypes.bool,
    preFill: (0, _propTypes.shape)({
      promoCode: _propTypes.string,
      from: _propTypes.string,
      to: _propTypes.string,
      tripType: _propTypes.string,
      depart: _propTypes.string,
      return: _propTypes.string,
      passengers: (0, _propTypes.shape)({
        adult: _propTypes.number,
        child: _propTypes.number,
        infant: _propTypes.number
      }),
      cabinClass: _propTypes.string,
      mixedClass: _propTypes.bool,
      isOC: _propTypes.string,
      isDC: _propTypes.string
    }),
    isLogin: _propTypes.bool,
    showMobileViewWithoutModal: _propTypes.bool,
    fireGtm: _propTypes.func,
    gtmParameters: (0, _propTypes.shape)({
      appName: _propTypes.string
    }),
    isSearchWidgetOpenByDefault: _propTypes.bool,
    showContextualSearchWidget: _propTypes.bool,
    contextualConfig: _contextualSearchWidget.default.PropTypes,
    isShowSnapCheckbox: _propTypes.bool,
    isShowSnapInNewWindow: _propTypes.bool,
    onValueChange: _propTypes.func,
    showBorder: _propTypes.bool,
    showBackGroundColor: _propTypes.string,
    showIconBackground: _propTypes.bool,
    customSearchHandler: _propTypes.func,
    agentId: _propTypes.string,
    invertSearchButtonStyle: _propTypes.bool,
    unifiedListingConfig: _propTypes.object,
    beforeRedirectHandler: _propTypes.func,
    originOrDestinationNotFoundEventHandler: _propTypes.func,
    maxPromoLength: _propTypes.number,
    showCabinClass: _propTypes.bool,
    showMixClass: _propTypes.bool,
    enableLFCV2: _propTypes.bool,
    airlineProfile: _propTypes.string,
    channelHash: _propTypes.string,
    authToken: _propTypes.string,
    domain: _propTypes.string,
    useV3Bucket: _propTypes.bool,
    enableOnSearchCookieReset: _propTypes.bool,
    isAirAsiaFlightOnlyCheckbox: _propTypes.bool,
    airAsiaFlightOnlyValueFromListing: _propTypes.bool,
    enableTravelSearchService: _propTypes.bool,
    enableSuggestion: _propTypes.bool
  },
  DefaultProps: {
    viewport: _constant2.DEVICE_TYPE.DESKTOP,
    theme: _constant.DEFAULT_THEME,
    showMobileViewWithoutModal: false,
    accessible: true,
    data: _data.DEFAULT_DATA,
    locale: _constant3.DEFAULT_LOCALE,
    geoid: _constant3.DEFAULT_GEOID,
    currency: _constant3.DEFAULT_CURRENCY,
    endpointConfig: _data.ENDPOINT_CONFIG,
    environment: _constant3.ENVIRONMENT.STAGING,
    enableDataVisor: false,
    isEdit: false,
    enableLFC: false,
    isSearchWidgetOpenByDefault: false,
    openContextualSearchWidgetbyDefault: false,
    isShowSnapCheckbox: false,
    isShowSnapInNewWindow: false,
    onValueChange: function onValueChange() {},
    showBorder: false,
    showBackGroundColor: 'default',
    showIconBackground: false,
    agentId: null,
    invertSearchButtonStyle: false,
    unifiedListingConfig: null,
    beforeRedirectHandler: null,
    hasBanner: false,
    bannerData: {},
    gtmParameters: {
      appName: 'Flights'
    },
    showCabinClass: false,
    showMixClass: false,
    domain: 'com',
    cityLevelGrouping: false,
    useV3Bucket: false,
    enableOnSearchCookieReset: false,
    isAirAsiaFlightOnlyCheckbox: false,
    airAsiaFlightOnlyValueFromListing: false,
    enableTravelSearchService: false,
    enableSuggestion: false
  }
};
exports.default = _default;